export const ID = Symbol('TGROUP_ID');
export const PATH = Symbol('TGROUP_PATH');
